import { useContext } from 'react'

import {
  Button, Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import useTaskListItem from '@hooks/useTaskListItem'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import UserSearch from '@components/UserSearch'

import useManageTaskListItems from './hooks/useManageTaskListItems'

import User from './components/User'

const MODAL_KEY = 'ManageTaskListItemsModal'

type ModalCallbacks = {
  closeModal: () => void,
  bulkUpdateTaskListItems: (payload: HandleCallbackActionParams) => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const ManageTaskListItemsModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal, bulkUpdateTaskListItems } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = modalData?.[MODAL_KEY] ?? {}
  const { taskListItemIds, resetItems } = modalPayload

  const useManageTaskListItemPayload = useManageTaskListItems()
  const { callbacks: { setState }, dueDate, selectedUser } = useManageTaskListItemPayload

  const { callbacks: { bulkUpdateTaskListItems: bulkUpdateFn }, updating } = useTaskListItem()

  const bulkUpdateTaskListItemsPayload = {
    callbacks: {
      action: bulkUpdateFn,
      afterAction: () => {
        resetItems()
        closeModal()
      },
    },
    // @ts-expect-error TS2339
    entityParams: { assigneeId: selectedUser?.id, dueDate, taskListItemIds },
    requestOptions: {
      include_image_sizes: true,
      include_task_list_item_assignee: true,
      include_user_image: true,
    },
    toastText: 'Tasks Assigned',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Manage" titleSecondLine="Task Details" />

      <SidebarModal.Content>
        <Form>
          <Form.Field label="Due Date">
            <input
              name="due_date"
              onChange={e => setState({ dueDate: e.target.value })}
              type="date"
              value={dueDate}
            />
          </Form.Field>

          <Form.Field
            direction="column"
            label="Assign User"
            marginTop="large"
          >
            <UserSearch
              callbacks={{
                // @ts-expect-error TS2322
                selectItem: user => setState({ selectedUser: user }),
              }}
              secondaryTextProperty="id"
            />
          </Form.Field>
        </Form>

        {/*
         // @ts-expect-error TS2339 */}
        {selectedUser?.id && (
          <Form.Field label="Selected User" marginTop="large">
            <User
              callbacks={{
                deleteUser: () => setState({ selectedUser: undefined }),
              }}
              user={selectedUser}
            />
          </Form.Field>
        )}
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          // @ts-expect-error TS2339
          disabled={!selectedUser?.id && !dueDate}
          loading={updating}
          loadingBubbleColor="white"
          // @ts-expect-error TS2345
          onClick={() => bulkUpdateTaskListItems(bulkUpdateTaskListItemsPayload)}
          size="large"
        >
          Update Details
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <ManageTaskListItemsModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
